import React from 'react';
import '../template-file-css/document-file-template.css';


export const PD_AnnualPacket = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='PD_AnnualPacket' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'>Member Name:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Member ID number:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Member date of birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtMemberName' name='txtMemberName' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtIdNumber' name='txtIdNumber' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center><h4>Healthy Louisiana Mental Health Rehabilitation Member Choice Form</h4></center>
                </p>

                <p className='w-750'>
                    <b>Member Information:</b>{`I am requesting services from a mental health rehabilitation (MHR) provider. I understand that I have the right to choose an agency to provide services to me or my child. I understand that I may only receive MHR services from one provider unless my health plan makes an exception. 1 may change providers if I am not satisfied with the services.`}
                </p>

                <p className='w-750'>
                    {`If assistance is needed with finding an MHR provider, review the list of providers located at your health plan's website below or call your plan for assistance.`}
                    <ol>
                        <li>
                            <b>Aetna:</b>{`www.aetnabetterhealth.com/louisiana/find-provider or call 1-855-242-0802 Hearing Impaired TTY/TDD 711`}
                        </li>
                        <li>
                            <b>Amerihealth Caritas Louisiana:</b>{`www.amerihealthcaritasla.com/member/eng/tools/find-provider.aspx or call 1-888-756-0004; TTY 1-866-428-7588`}
                        </li>
                        <li>
                            <b>Healthy Blue:</b>{`www.myhealthybluela.com/la/care/find-a-doctor.html or call 1-844-227-8350 (TTY 711)`}
                        </li>
                        <li>
                            <b>Louisiana Healthcare Connections:</b>{`https://providersearch.louisianahealthconnect.com/or call 1-866-595-8133 (Hearing Loss: 711)`}
                        </li>
                        <li>
                            <b>United Healthcare Community:</b>{`www.uhccommunityplan.com/la/medicaid/healthy-louisiana.html or call 1-866-675-1607 TTY: 1-877-4285-4514`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>The provider that I have freely selected to deliver MHR services to me or my child is:</b>
                </p>

                <table>
                    <tr>
                        <td className='w-300'><b>Provider Name:</b></td>
                        <td className='w-450'>Positive Direction Support Services</td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Provider Phone Number:</b></td>
                        <td className='w-450'>(504) 944-0453</td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Provider Contact Name:</b></td>
                        <td className='w-450'>Donnyette J. Love, LCSW, BACS</td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Provider Address:</b></td>
                        <td className='w-450'>1995 Gentilly Blvd. Ste. C-400, New Orleans, LA 70119</td>
                    </tr>
                </table>

                <p className='w-750'>
                    {`By signing the form below. I understand that I have chosen to receive services from this MHR provider and I acknowledge that it is my responsibility to notify my previous provider, so they can coordinate my care with my new provider. I understand that l am free ta choose any MHR provider in my health plan's network.`}
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Member/Legal Guardian Signature:</td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Printed Legal Guardian Name (if applicable) </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>Providers Information:</b>{`A Member Choice form is required prior to receiving any mental health rehabilitation services. This form requires member/legal guardian signature, date, identified provider with telephone and contact name. The provider is responsible for coordinating the transition of care with the member's previous provider prior to starting services.`}
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Provider Signature:</td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center><h4>Positive Direction Support Services</h4></center>
                </p>

                <p className='w-750'>
                    <center><h4>Responsibilities of Person Served</h4></center>
                </p>

                <p className='w-750'>
                    <b>As a member, you have the responsibility to:</b>
                    <ul>
                        <li>
                            {`Meet with assigned workers on a regular basis at your home, in the community or other mutually agreed upon location.`}
                        </li>
                        <li>
                            Attend all Psychiatry and Medical appointments.
                        </li>
                        <li>
                            {`Participate in the services identified by yourself and your treatment team, including taking medication(s) as prescribed.`}
                        </li>
                        <li>
                            {`Work together with your worker by sharing accurate information about your treatment and any problems/concerns you may have which interfere with your goals and treatment progress.`}
                        </li>
                        <li>
                            Actively help your worker in planning your services and deciding what actions are helpful and needed.
                        </li>
                        <li>
                            {`Allow your workers to receive and share information we need from other agencies, doctors, schools, etc. to access or coordinate services that you request.`}
                        </li>
                        <li>
                            {`Try, to the best of your ability, to achieve treatment and service goals that are planned. One step at a time!`}
                        </li>
                        <li>
                            Come to counseling on time.
                        </li>
                        <li>
                            Call if you cannot make counseling sessions.
                        </li>
                    </ul>
                </p>

                <p className='w-750'>
                    <b>NOTICE:</b> This entire document is reprinted in the Client Handbook which every client receives.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> CLIENT NAME </td>
                        <td className='small w-250'> DATE OF BIRTH </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> PARENT/GUARDIAN SIGNATURE </td>
                        <td className='small w-250'> DATE </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> STAFF SIGNATURE </td>
                        <td className='small w-250'> DATE </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center><h4>Positive Direction Support Services</h4></center>
                </p>

                <p className='w-750'>
                    <center><h4>Informed consent to treatment</h4></center>
                </p>

                <p className='w-750'>
                    <ol>
                        <li>
                            {`I will be given a clear description from my mental health provider regarding the problems, diagnosis, personal strengths/limitations and treatment interventions proposed.`}
                        </li>
                        <li>
                            {`I will be given a clear recommendation for the types of treatment recommended, such as individual counseling/therapy, group counseling/therapy, family counseling/therapy, addictions counseling, and/or psychiatric services. Times, dates, and session length will be discussed with my mental health provider.`}
                        </li>
                        <li>
                            {`I voluntarily agree to undergo mental health treatment and understand that I may end treatment at any time. I understand that my mental health provider may want to discuss this with me, but that I reserve the right to stop treatment. In the cases of minors, please see addendum form - "Consent to Mental Health Treatment for Minors". Furthermore, I understand that my mental health provider may make diagnostic and treatment recommendations with which I do not agree (e.g. modality of treatment, duration of treatent, frequency of visits, etc.).`}
                        </li>
                        <li>
                            {`I understand that my mental health provider cannot guarantee results (e.g., less depressed, etc.) of mental health services. However, there will be clearly stated reasons, goals, and objectives for continuing/discontinuing mental health treatment. This will be discussed with my mental health provider.`}
                        </li>
                        <li>
                            {`I understand that there may be some risks in participating in mental health services. These may include, but are not limited to, addressing painful emotional experiences and/or feelings; being challenged or confronted on a particular issue; re-uniting with family members; etc. I am aware that I can discuss any unforeseen risks vs. benefts with my mental health provider at any time. In the case of psychiatric care, medications, side effects, and alternative treatments will be discussed.`}
                        </li>
                        <li>
                            {`I understand that I have the right to an interpreter (sign or language) if necessary.`}
                        </li>
                        <li>
                            {`I understand that in the case of an emergency, Positive Direction Support Services maintains a 24 hour emergency "on call" system. Emergencies are generally life-threatening in nature. I have discussed with my mental health provider how to access this service.`}
                        </li>
                        <li>
                            {`I understand that if I have a grievance with my mental health provider, I will first attempt to communicate this directly to him/ber. In the event that the grievance is not satisfactorily resolved, I understand how to complete a "Reasonable Accommodations Request Form" (located in the waiting area).`}
                        </li>
                        <li>
                            {`I understand that this "Informed Consent/Limits of Confidentiality Form" is not intended to be "all inclusive" of aspects of my mental health treatment. It is only intended to provide some useful information before deciding to engage in mental health treatment.`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <center><h4>Limits of Confidentiality</h4></center>
                </p>

                <p className='w-750'>
                    <b>I. The information that you share with your Mental Health Provider is considered to be confidential. In most cases, information cannot be released to another party without your written consent. However, in certain circumstances, information can be shared legally without your permission. These circumstances include:</b>
                    <ol>
                        <li>
                            <b>Suicide:</b>{`if you are assessed to be a danger to yourself; cannot guarantee your physical safety against the intention of suicide, and/or have immediate suicidal plans, this information is not considered to be "confidential". Actions may be taken to ensure your safety.`}
                        </li>
                        <li>
                            <b>Homicide:</b>{`if you are assessed to be a danger to others; cannot guarantee their safety; and have immediate, specific plans to cause fatal injury/harm to another person, this information is not considered to be "confidential". Actions may be taken to protect the safety of others. The police may be notified of your intentions as well as the intended victim.`}
                        </li>
                        <li>
                            <b>Court order/subpoena:</b>{`Your Mental Health Provider(s) can be required to relinquish a copy of your written Mental Health Record to the appropriate Courts. Mental Health Providers can also be subpoenaed to testify in court without your consent.`}
                        </li>
                        <li>
                            <b>Child abuse/neglect:</b>{`Louisiana Law requires your Mental Health Provider to report to the appropriate authorities (i.e. Child Protective Services) any suspicion or evidence of child abuse or neglect. This law also applies to past incidents of abuse or neglect.`}
                        </li>
                        <li>
                            <b>Laws regarding minors in mental health services:</b>{`certain information may be shared with parent/legal guardians at the discretion of the mental health provider (s).`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>II. Mental Health confidential information may also be used in a number of ways within Positive Direction Support Services without your written permission for coordinating services and delivering quality care. You may be informed if this is the case. These may include:</b>
                    <ol>
                        <li>
                            Consultations and case conference with other providers at Positive Direction Support Services.
                        </li>
                        <li>
                            In supervisory meetings with student interns at Positive Direction Support Services.
                        </li>
                        <li>
                            {`With providers in other services here at Positive Direction Support Services (your doctor, nurse, or case manager).`}
                        </li>
                        <li>
                            For anonymous research purposes at Positive Direction Support Services.
                        </li>
                        <li>
                            {`For billing purposes: a diagnosis is given to your insurer for reimbursement purposes, Including Magellan of Louisiana Health Partners, Medicaid, and/or private insurance companies/HMO's.`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>III. Other Notes on Your Privacy & Biling/Fee Information:</b>
                    <ol>
                        <li>
                            Please indicate on the Client Demographic Form how we may contact you.
                        </li>
                        <li>
                            {`Video and audio taping: occasionally, Mental Health Providers will want to make an audio/video recording of your sessions. Your written permission in required. YOU HAVE THE RIGHT TO REFUSE THIS.`}
                        </li>
                        <li>
                            {`Generally, you will be contacted by phone or mail. Internet email is discouraged unless discussed with your therapist.`}
                            <br />
                            <b>PLEASE NOTE:</b>PRIVACY AND CONFIDENTIALITY OVER THE INTERNET CANNOT BE GUARANTEED.
                        </li>
                        <li>
                            I have discussed my insurance coverage and fees with the Mental Health Benefits Coordinator prior to this appointment. I understand that I am responsible for any co- pays or fees not covered by third parties.
                        </li>
                        <li>
                            {`I understand that it is the policy of Positive Direction Support Services to discharge a patient after three (3) missed appointments. In the event that I do not call to cancel an appointment with 24 hours notice this is considered to be a missed appointment. It is recommended that patients do not miss appointments as these are a benefit to the patient's mental health success.`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>{`I have reviewed this "Informed Consent to Treatment/Limits of Confidentiality" information with my mental health provider. I have been given the opportunity to ask questions about this information. A copy of this information is available upon request. By signing this, I indicate my understanding of this information.`}</b>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Name </td>
                        <td className='small w-250'> Date of Birth </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent/Guardian Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Mental Health Provider Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center><h4>Positive Direction Support Services</h4></center>
                </p>

                <p className='w-750'>
                    <center><h4>Rights of the Persons Served and Notice of Privacy Practices</h4></center>
                </p>

                <p className='w-750'>
                    <center><h4>Rights of the Persons Served</h4></center>
                </p>

                <p className='w-750'>
                    <b>Positive Direction Support Services believes that all clients and human beings have these rights:</b>
                    <ol>
                        <li>
                            {`To choose a provider of behavioral health services, from an approved list of providers maintained by Magellan Health Services ("freedom of choice");`}
                        </li>
                        <li>
                            {`To be accepted for services only if this agency has the ability to provide services at the level of intensity needed by the individual;`}
                        </li>
                        <li>
                            {`To be treated with dignity and respect as an individual who has personal needs, feelings, preferences and requirements;`}
                        </li>
                        <li>
                            {`To privacy in treatment, in care, and in the fulfillment of personal needs;`}
                        </li>
                        <li>
                            {`To be fully informed of all available services and of charges for these services;`}
                        </li>
                        <li>
                            {`To be fully informed of all rights as a member and of all rules and regulations governing conduct as a member in this facility;`}
                        </li>
                        <li>
                            {`To manage personal financial affairs; thereby, if assistance is requested, this agency will arrange appropriate assistance for the individual;`}
                        </li>
                        <li>
                            {`To participate in the development of an individual service plan;`}
                        </li>
                        <li>
                            {`To receive information necessary to give informed consent prior to the start of any services and /or treatment;`}
                        </li>
                        <li>
                            {`To refuse treatment to the extent permitted by law and be informed of the consequences of this right;`}
                        </li>
                        <li>
                            {`To the continuity of care which includes not being discharged or transferred except for medical reasons for the individual's personal`}
                        </li>
                        <li>
                            {`Welfare, or for the welfare of others; therefore, should transfer or discharge become necessary; the member will be given reasonable advance notice, unless an emergency situation exists;`}
                        </li>
                        <li>
                            {`To voice opinion, recommendations and grievances in relation to policies, staff and services offered by the facility without fear of restraint, interference, coercion, discrimination, or reprisal;`}
                        </li>
                        <li>
                            To be free from:
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <ol type='a'>
                        <li>
                            {`physical, chemical, or mental abuse;`}
                        </li>
                        <li>
                            {`financial or other exploitation;`}
                        </li>
                        <li>
                            {`retaliation;`}
                        </li>
                        <li>
                            {`humiliation; and/or`}
                        </li>
                        <li>
                            {`neglect;`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>15.</b>{`To confidential treatment of all personal and medical records, in accordance with the agency's Notice of Privacy Practices;`}
                </p>

                <p className='w-750'>
                    <b>16.</b>{`To refuse to perform any service for the facility, or for other members, unless they are a part of a therapeutic plan of treatment which the member has approyed;`}
                </p>

                <p className='w-750'>
                    <b>17.</b>{`To all benefits and privileges guaranteed by Federal, State, and local law, except those specifically lost through the due process of law;`}
                </p>

                <p className='w-750'>
                    <b>18.</b>{`To live in their community of choice without restraints on independence, except those restraints to which all citizens are subject:`}
                </p>

                <p className='w-750'>
                    <b>19.</b>{`To receive services without discrimination based on race color sex, sexual orientation, age, religion, national origin, domestic/marital status, political affiliation or opinion, veteran’s status, physical/mental handicap or ability to pay for services;`}
                </p>

                <p className='w-750'>
                    <b>20.</b>{`To access guardians, self-help groups; advocacy services and legal services at any time; access will be facilitated through an assigned community support worker; and, to be ensured of Informed Consent regarding:`}
                    <ol type='a'>
                        <li>
                            {`Service delivery;`}
                        </li>
                        <li>
                            {`Release of information;`}
                        </li>
                        <li>
                            {`Concurrent seisces;`}
                        </li>
                        <li>
                            {`Composition of the service delivery team; and,`}
                        </li>
                        <li>
                            {`Involvement in research projects, when applicable.`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>21.</b>{`If the individual being served is a minor or has a court-appointed guardian or other legal representative, all information outlined above will be provided to the guardian or legal representative, as well as to the individual served, for as long as the individual requires it.`}
                </p>

                <p className='w-750'>
                    <center><h4>Individual Rights Related to Privacy Practices (NPP)</h4></center>
                </p>

                <p className='w-750'>
                    <b>Consistent with the provisions of the Privacy Rule, PDS assures the rights of individuals to:</b>
                    <ol>
                        <li>
                            Have access to their health information;
                        </li>
                        <li>
                            {`Have written, meaningful notice regarding the ways in which their health information is used and disclosed;`}
                        </li>
                        <li>
                            {`Have an opportunity to request restrictions to the use and disclosure of their health information, and to have reasonable requests honored;`}
                        </li>
                        <li>
                            {`Have an opportunity to request corrections or amendments to their health information;`}
                        </li>
                        <li>
                            {`Receive, upon written request, an accounting of the disclosures made of their health information;`}
                        </li>
                        <li>
                            {`File complaints regarding the organization's use or disclosure of private health information, and to be free from retaliation for having filed such a complaint or complaints; and`}
                        </li>
                        <li>
                            {`To further protect the privacy of individuals during service delivery:`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <ol type='a'>
                        <li>
                            {`Services are delivered in areas that respect the privacy of the individual served;`}
                        </li>
                        <li>
                            {`Conversations with or about the individual served are conducted in such a manner that others not involved in the case do not overhear; and,`}
                        </li>
                        <li>
                            {`The identity of individual served or their families are not revealed during the transmission of information via e-mail, texting; blogging, or other social media such as Facebook or Twitter.`}
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <b>NOTICE:</b> This entire document is reprinted in the Client Handbook which every client receives.
                </p>

                <p className='w-750'>
                    <center><h4>Authorisation to Release or Obtain Health Information
                        <br /> For Eligibility in Program Enrollment</h4>
                        <span className='small'>(including paper, oral and electronic information)</span></center>
                </p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Request Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Mailing Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtMailingAddress' name='txtMailingAddress' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth_1' name='txtDateOfBirth_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Medicaid ID# or Social Security#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCity' name='txtCity' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMedicaidId' name='txtMedicaidId' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>I authorize:</b></p>

                <p className='small w-750'>
                    <center><b>Name:</b> Positive Direction Support Services, LLC <br />
                        <b>Mailing Address:</b> 1995 Gentilly Blvd. Suite C-400
                        <br />
                        <b>City, State, Zip Code:</b> New Orleans, LA 70119
                        <br />
                        <b>Phone #:</b> (504) 944-0453 Office (504) 944-0095 Fax
                        <br />
                        <b>Relationship:</b> Behavioral Health Agency
                    </center>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbReleaseInformation' name='cbReleaseInformation' className='add-only' value='To Release' /> To Release Information TO &nbsp; &nbsp; OR &nbsp; &nbsp;
                    <input type='checkbox' id='cbObtainInformation' name='cbObtainInformation' className='add-only' value='To Obtain' /> To Obtain Information FROM
                </p>

                <p className='w-750'>
                    {`(Place an "X" in the box that indicates if the information is being released OR requested.)`}
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Name:</span>
                    <input type='text' id='txtName_1' name='txtName_1' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Mailing Address:</span>
                    <input type='text' id='txtMailingAddress_1' name='txtMailingAddress_1' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>City:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>State:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Zip Code:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCity_1' name='txtCity_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtState' name='txtState' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtZipCode' name='txtZipCode' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Relationship:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Telephone #:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Fax#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTelephone' name='txtTelephone' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtFax' name='txtFax' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>I authorize the release of the following protected health information.</b>
                </p>

                <p className='w-750'>
                    {`(Place an "X" in the box (es) that apply to the information you want released or you want to obtain.)`}
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEntireRecord' name='cbEntireRecord' className='add-only' value='Entire Record' /> Entire Record </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicalHistory' name='cbMedicalHistory' className='add-only' value='Medical History' /> Medical History, Examination, Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrescriptions' name='cbPrescriptions' className='add-only' value='Prescriptions' /> Prescriptions </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbImmunizations' name='cbImmunizations' className='add-only' value='Immunizations' /> Immunizations </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHospitalRecords' name='cbHospitalRecords' className='add-only' value='Hospital Records' /> Hospital Records including Reports </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLaboratoryReports' name='cbLaboratoryReports' className='add-only' value='Laboratory Reports' /> Laboratory Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbXrayReports' name='cbXrayReports' className='add-only' value='X-ray Reports' /> X-ray Reports </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMrReports' name='cbMrReports' className='add-only' value='MR/DD Reports' /> MR/DD Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOther' name='txtOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>{`In compliance with state and/or federal laws which require special permission to release otherwise privileged information, please release the following records.`}</b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAlcoholism' name='cbAlcoholism' className='add-only' value='Alcoholism' /> Alcoholism </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDrugAbuse' name='cbDrugAbuse' className='add-only' value='Drug Abuse' /> Drug Abuse </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealth' name='cbMentalHealth' className='add-only' value='Mental Health' /> Mental Health </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbVocationalRehabilitation' name='cbVocationalRehabilitation' className='add-only' value='Vocational Rehabilitation' /> Vocational Rehabilitation </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAids' name='cbAids' className='add-only' value='HIV (AIDS)' /> HIV (AIDS) </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSexuallyTransmitted' name='cbSexuallyTransmitted' className='add-only' value='Sexually Transmitted Diseases' /> Sexually Transmitted Diseases </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbGenetics' name='cbGenetics' className='add-only' value='Genetics' /> Genetics </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychotherapyNotes' name='cbPsychotherapyNotes' className='add-only' value='Psychotherapy Notes' /> Psychotherapy Notes </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_1' name='cbOther_1' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOther_1' name='txtOther_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    This authorization shall expire on &nbsp;
                    <input type='text' id='txtAuthorization' name='txtAuthorization' placeholder='(date or event)' className='add-only w-250 custom-add-only' /> &nbsp;
                    and is needed for the period beginning &nbsp;
                    <input type='text' id='txtPeriodBeginning' name='txtPeriodBeginning' className='add-only w-200 custom-add-only' /> &nbsp;
                    and ending &nbsp;
                    <input type='text' id='txtEnding' name='txtEnding' className='add-only w-200 custom-add-only' /> .
                </p>

                <p className='w-750'>
                    {`I understand that if I do not specify an expiration date, this authorization will expire one (1) year from the date on which it was signed. I acknowledge that I have read this form.`}
                </p>

                <p className='signature w-750'>&nbsp; </p>
                <p className='small w-750'> Signature of Individual or Personal Representative Authorized by Law Date </p>

                <p className='signature w-750'>&nbsp; </p>
                <p className='small w-750'> Signature of Witness (If signed with an "X" or mark) Date </p>

                <p className='w-750'>
                    <center><h4>Authorisation to Release or Obtain Health Information
                        <br /> For Eligibility in Program Enrollment</h4>
                        <span className='small'>(including paper, oral and electronic information)</span></center>
                </p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Request Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtLastName_1' name='txtLastName_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Mailing Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtMailingAddress_2' name='txtMailingAddress_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth_2' name='txtDateOfBirth_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Medicaid ID# or Social Security#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCity_2' name='txtCity_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMedicaidId_1' name='txtMedicaidId_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>I authorize:</b></p>

                <p className='w-750'>
                    <center>
                        <b>Name:</b> Positive Direction Support Services, LLC
                        <br />
                        <b>Mailing Address:</b> 1995 Gentilly Blvd. Suite C-400
                        <br />
                        <b>City, State, Zip Code:</b> New Orleans, LA 70119
                        <br />
                        <b>Phone #:</b> (504) 944-0453 Office (504) 944-0095 Fax
                        <br />
                        <b>Relationship:</b> Behavioral Health Agency
                    </center>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbReleaseInformation_1' name='cbReleaseInformation_1' className='add-only' value='To Release' /> To Release Information TO &nbsp; &nbsp; OR &nbsp; &nbsp;
                    <input type='checkbox' id='cbObtainInformation_1' name='cbObtainInformation_1' className='add-only' value='To Obtain' /> To Obtain Information FROM
                </p>

                <p className='w-750'>
                    {`(Place an "X" in the box that indicates if the information is being released OR requested.)`}
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Name:</span>
                    <input type='text' id='txtName_3' name='txtName_3' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Mailing Address:</span>
                    <input type='text' id='txtMailingAddress_3' name='txtMailingAddress_3' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>City:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>State:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Zip Code:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCity_3' name='txtCity_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtState_1' name='txtState_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtZipCode_1' name='txtZipCode_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Relationship:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Telephone #:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Fax#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtRelationship_1' name='txtRelationship_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTelephone_1' name='txtTelephone_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtFax_1' name='txtFax_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>I authorize the release of the following protected health information.</b>
                </p>

                <p className='w-750'>
                    {`(Place an "X" in the box (es) that apply to the information you want released or you want to obtain.)`}
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEntireRecord_1' name='cbEntireRecord_1' className='add-only' value='Entire Record' /> Entire Record </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicalHistory_1' name='cbMedicalHistory_1' className='add-only' value='Medical History' /> Medical History, Examination, Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrescriptions_1' name='cbPrescriptions_1' className='add-only' value='Prescriptions' /> Prescriptions </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbImmunizations_1' name='cbImmunizations_1' className='add-only' value='Immunizations' /> Immunizations </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHospitalRecords_1' name='cbHospitalRecords_1' className='add-only' value='Hospital Records' /> Hospital Records including Reports </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLaboratoryReports_1' name='cbLaboratoryReports_1' className='add-only' value='Laboratory Reports' /> Laboratory Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbXrayReports_1' name='cbXrayReports_1' className='add-only' value='X-ray Reports' /> X-ray Reports </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMrReports_1' name='cbMrReports_1' className='add-only' value='MR/DD Reports' /> MR/DD Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_2' name='cbOther_2' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOther_2' name='txtOther_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>{`In compliance with state and/or federal laws which require special permission to release otherwise privileged information, please release the following records.`}</b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAlcoholism_1' name='cbAlcoholism_1' className='add-only' value='Alcoholism' /> Alcoholism </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDrugAbuse_1' name='cbDrugAbuse_1' className='add-only' value='Drug Abuse' /> Drug Abuse </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealth_1' name='cbMentalHealth_1' className='add-only' value='Mental Health' /> Mental Health </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbVocationalRehabilitation_1' name='cbVocationalRehabilitation_1' className='add-only' value='Vocational Rehabilitation' /> Vocational Rehabilitation </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAids_1' name='cbAids_1' className='add-only' value='HIV (AIDS)' /> HIV (AIDS) </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSexuallyTransmitted_1' name='cbSexuallyTransmitted_1' className='add-only' value='Sexually Transmitted Diseases' /> Sexually Transmitted Diseases </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbGenetics_1' name='cbGenetics_1' className='add-only' value='Genetics' /> Genetics </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychotherapyNotes_1' name='cbPsychotherapyNotes_1' className='add-only' value='Psychotherapy Notes' /> Psychotherapy Notes </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_3' name='cbOther_3' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOther_3' name='txtOther_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    This authorization shall expire on &nbsp;
                    <input type='text' id='txtAuthorization_1' name='txtAuthorization_1' placeholder='(date or event)' className='add-only w-250 custom-add-only' /> &nbsp;
                    and is needed for the period beginning &nbsp;
                    <input type='text' id='txtPeriodBeginning_1' name='txtPeriodBeginning_1' className='add-only w-200 custom-add-only' /> &nbsp;
                    and ending &nbsp;
                    <input type='text' id='txtEnding_1' name='txtEnding_1' className='add-only w-200 custom-add-only' /> .
                </p>

                <p className='w-750'>
                    {`I understand that if I do not specify an expiration date, this authorization will expire one (1) year from the date on which it was signed. I acknowledge that I have read this form.`}
                </p>

                <p className='signature w-750'>&nbsp; </p>
                <p className='small w-750'> Signature of Individual or Personal Representative Authorized by Law Date </p>

                <p className='signature w-750'>&nbsp; </p>
                <p className='small w-750'> Signature of Witness (If signed with an "X" or mark) Date </p>



                <p className='w-750'>
                    <center><h4>Authorisation to Release or Obtain Health Information
                        <br /> For Eligibility in Program Enrollment</h4>
                        <span className='small'>(including paper, oral and electronic information)</span></center>
                </p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Request Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtName_4' name='txtName_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtLastName_2' name='txtLastName_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Mailing Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtMailingAddress_4' name='txtMailingAddress_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth_3' name='txtDateOfBirth_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Medicaid ID# or Social Security#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCity_4' name='txtCity_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMedicaidId_2' name='txtMedicaidId_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>I authorize:</b></p>

                <p className='w-750'>
                    <center>
                        <b>Name:</b> Positive Direction Support Services, LLC
                        <br />
                        <b>Mailing Address:</b> 1995 Gentilly Blvd. Suite C-400
                        <br />
                        <b>City, State, Zip Code:</b> New Orleans, LA 70119
                        <br />
                        <b>Phone #:</b> (504) 944-0453 Office (504) 944-0095 Fax
                        <br />
                        <b>Relationship:</b> Behavioral Health Agency
                    </center>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbReleaseInformation_2' name='cbReleaseInformation_2' className='add-only' value='To Release' /> To Release Information TO &nbsp; &nbsp; OR &nbsp; &nbsp;
                    <input type='checkbox' id='cbObtainInformation_2' name='cbObtainInformation_2' className='add-only' value='To Obtain' /> To Obtain Information FROM
                </p>

                <p className='w-750'>
                    {`(Place an "X" in the box that indicates if the information is being released OR requested.)`}
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Name:</span>
                    <input type='text' id='txtName_5' name='txtName_5' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Mailing Address:</span>
                    <input type='text' id='txtMailingAddress_5' name='txtMailingAddress_5' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>City:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>State:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Zip Code:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCity_5' name='txtCity_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtState_2' name='txtState_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtZipCode_2' name='txtZipCode_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Relationship:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Telephone #:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Fax#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtRelationship_2' name='txtRelationship_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTelephone_2' name='txtTelephone_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtFax_2' name='txtFax_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>I authorize the release of the following protected health information.</b>
                </p>

                <p className='w-750'>
                    {`(Place an "X" in the box (es) that apply to the information you want released or you want to obtain.)`}
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEntireRecord_2' name='cbEntireRecord_2' className='add-only' value='Entire Record' /> Entire Record </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicalHistory_2' name='cbMedicalHistory_2' className='add-only' value='Medical History' /> Medical History, Examination, Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrescriptions_2' name='cbPrescriptions_2' className='add-only' value='Prescriptions' /> Prescriptions </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbImmunizations_2' name='cbImmunizations_2' className='add-only' value='Immunizations' /> Immunizations </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHospitalRecords_2' name='cbHospitalRecords_2' className='add-only' value='Hospital Records' /> Hospital Records including Reports </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLaboratoryReports_2' name='cbLaboratoryReports_2' className='add-only' value='Laboratory Reports' /> Laboratory Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbXrayReports_2' name='cbXrayReports_2' className='add-only' value='X-ray Reports' /> X-ray Reports </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMrReports_2' name='cbMrReports_2' className='add-only' value='MR/DD Reports' /> MR/DD Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_4' name='cbOther_4' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOther_4' name='txtOther_4' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>{`In compliance with state and/or federal laws which require special permission to release otherwise privileged information, please release the following records.`}</b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAlcoholism_2' name='cbAlcoholism_2' className='add-only' value='Alcoholism' /> Alcoholism </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDrugAbuse_2' name='cbDrugAbuse_2' className='add-only' value='Drug Abuse' /> Drug Abuse </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealth_2' name='cbMentalHealth_2' className='add-only' value='Mental Health' /> Mental Health </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbVocationalRehabilitation_2' name='cbVocationalRehabilitation_2' className='add-only' value='Vocational Rehabilitation' /> Vocational Rehabilitation </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAids_2' name='cbAids_2' className='add-only' value='HIV (AIDS)' /> HIV (AIDS) </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSexuallyTransmitted_2' name='cbSexuallyTransmitted_2' className='add-only' value='Sexually Transmitted Diseases' /> Sexually Transmitted Diseases </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbGenetics_2' name='cbGenetics_2' className='add-only' value='Genetics' /> Genetics </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychotherapyNotes_2' name='cbPsychotherapyNotes_2' className='add-only' value='Psychotherapy Notes' /> Psychotherapy Notes </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_5' name='cbOther_5' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOther_5' name='txtOther_5' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    This authorization shall expire on &nbsp;
                    <input type='text' id='txtAuthorization_2' name='txtAuthorization_2' placeholder='(date or event)' className='add-only w-250 custom-add-only' /> &nbsp;
                    and is needed for the period beginning &nbsp;
                    <input type='text' id='txtPeriodBeginning_2' name='txtPeriodBeginning_2' className='add-only w-200 custom-add-only' /> &nbsp;
                    and ending &nbsp;
                    <input type='text' id='txtEnding_2' name='txtEnding_2' className='add-only w-200 custom-add-only' /> .
                </p>

                <p className='w-750'>
                    {`I understand that if I do not specify an expiration date, this authorization will expire one (1) year from the date on which it was signed. I acknowledge that I have read this form.`}
                </p>

                <p className='signature w-750'>&nbsp; </p>
                <p className='small w-750'> Signature of Individual or Personal Representative Authorized by Law Date </p>

                <p className='signature w-750'>&nbsp; </p>
                <p className='small w-750'> Signature of Witness (If signed with an "X" or mark) Date </p>

                <p className='w-750'>
                    <center><h4>Authorisation to Release or Obtain Health Information
                        <br /> For Eligibility in Program Enrollment</h4>
                        <span className='small'>(including paper, oral and electronic information)</span></center>
                </p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Request Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtName_6' name='txtName_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtLastName_3' name='txtLastName_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Mailing Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtMailingAddress_6' name='txtMailingAddress_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth_4' name='txtDateOfBirth_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Medicaid ID# or Social Security#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCity_6' name='txtCity_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMedicaidId_3' name='txtMedicaidId_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>I authorize:</b></p>

                <p className='w-750'>
                    <center>
                        <b>Name:</b> Positive Direction Support Services, LLC
                        <br />
                        <b>Mailing Address:</b> 1995 Gentilly Blvd. Suite C-400
                        <br />
                        <b>City, State, Zip Code:</b> New Orleans, LA 70119
                        <br />
                        <b>Phone #:</b> (504) 944-0453 Office (504) 944-0095 Fax
                        <br />
                        <b>Relationship:</b> Behavioral Health Agency
                    </center>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbReleaseInformation_3' name='cbReleaseInformation_3' className='add-only' value='To Release' /> To Release Information TO &nbsp; &nbsp; OR &nbsp; &nbsp;
                    <input type='checkbox' id='cbObtainInformation_3' name='cbObtainInformation_3' className='add-only' value='To Obtain' /> To Obtain Information FROM
                </p>

                <p className='w-750'>
                    {`(Place an "X" in the box that indicates if the information is being released OR requested.)`}
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Name:</span>
                    <input type='text' id='txtName_7' name='txtName_7' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Mailing Address:</span>
                    <input type='text' id='txtMailingAddress_7' name='txtMailingAddress_7' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>City:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>State:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Zip Code:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCity_7' name='txtCity_7' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtState_3' name='txtState_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtZipCode_3' name='txtZipCode_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Relationship:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Telephone #:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Fax#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtRelationship_3' name='txtRelationship_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTelephone_3' name='txtTelephone_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtFax_3' name='txtFax_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>I authorize the release of the following protected health information.</b>
                </p>

                <p className='w-750'>
                    {`(Place an "X" in the box (es) that apply to the information you want released or you want to obtain.)`}
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEntireRecord_3' name='cbEntireRecord_3' className='add-only' value='Entire Record' /> Entire Record </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicalHistory_3' name='cbMedicalHistory_3' className='add-only' value='Medical History' /> Medical History, Examination, Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrescriptions_3' name='cbPrescriptions_3' className='add-only' value='Prescriptions' /> Prescriptions </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbImmunizations_3' name='cbImmunizations_3' className='add-only' value='Immunizations' /> Immunizations </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHospitalRecords_3' name='cbHospitalRecords_3' className='add-only' value='Hospital Records' /> Hospital Records including Reports </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLaboratoryReports_3' name='cbLaboratoryReports_3' className='add-only' value='Laboratory Reports' /> Laboratory Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbXrayReports_3' name='cbXrayReports_3' className='add-only' value='X-ray Reports' /> X-ray Reports </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMrReports_3' name='cbMrReports_3' className='add-only' value='MR/DD Reports' /> MR/DD Reports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_6' name='cbOther_6' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOther_6' name='txtOther_6' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>{`In compliance with state and/or federal laws which require special permission to release otherwise privileged information, please release the following records.`}</b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAlcoholism_3' name='cbAlcoholism_3' className='add-only' value='Alcoholism' /> Alcoholism </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDrugAbuse_3' name='cbDrugAbuse_3' className='add-only' value='Drug Abuse' /> Drug Abuse </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealth_3' name='cbMentalHealth_3' className='add-only' value='Mental Health' /> Mental Health </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbVocationalRehabilitation_3' name='cbVocationalRehabilitation_3' className='add-only' value='Vocational Rehabilitation' /> Vocational Rehabilitation </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAids_3' name='cbAids_3' className='add-only' value='HIV (AIDS)' /> HIV (AIDS) </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSexuallyTransmitted_3' name='cbSexuallyTransmitted_3' className='add-only' value='Sexually Transmitted Diseases' /> Sexually Transmitted Diseases </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbGenetics_3' name='cbGenetics_3' className='add-only' value='Genetics' /> Genetics </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychotherapyNotes_3' name='cbPsychotherapyNotes_3' className='add-only' value='Psychotherapy Notes' /> Psychotherapy Notes </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_7' name='cbOther_7' className='add-only' value='Other' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOther_7' name='txtOther_7' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    This authorization shall expire on &nbsp;
                    <input type='text' id='txtAuthorization_3' name='txtAuthorization_3' placeholder='(date or event)' className='add-only w-250 custom-add-only' /> &nbsp;
                    and is needed for the period beginning &nbsp;
                    <input type='text' id='txtPeriodBeginning_3' name='txtPeriodBeginning_3' className='add-only w-200 custom-add-only' /> &nbsp;
                    and ending &nbsp;
                    <input type='text' id='txtEnding_3' name='txtEnding_3' className='add-only w-200 custom-add-only' /> .
                </p>

                <p className='w-750'>
                    {`I understand that if I do not specify an expiration date, this authorization will expire one (1) year from the date on which it was signed. I acknowledge that I have read this form.`}
                </p>

                <p className='signature w-750'>&nbsp; </p>
                <p className='small w-750'> Signature of Individual or Personal Representative Authorized by Law Date </p>

                <p className='signature w-750'>&nbsp; </p>
                <p className='small w-750'> Signature of Witness (If signed with an "X" or mark) Date </p>

                <p className='w-750'>
                    <center><h4>Parental Consent Form for School Visit</h4></center>
                </p>

                <p className='w-750'>
                    I, &nbsp;
                    <input type='text' id='txtGuardian' name='txtGuardian' placeholder='(parent/guardian)' className='add-only w-200 custom-add-only' /> &nbsp;
                    consent / decline for my child &nbsp;
                    <input type='text' id='txtDecline' name='txtDecline' className='add-only w-200 custom-add-only' /> &nbsp;
                    to be seen at his/her school &nbsp;
                    <input type='text' id='txtNameOfSchool' name='txtNameOfSchool' placeholder='(name of school)' className='add-only w-200 custom-add-only' /> &nbsp;
                    by the staff of Positive Direction Support Services during the academic school year &nbsp;
                    <input type='text' id='txtYear' name='txtYear' className='add-only w-100 custom-add-only' />.
                    The school's telephone number is &nbsp;
                    <input type='text' id='txtTelephoneNumber' name='txtTelephoneNumber' className='add-only w-150 custom-add-only' />. &nbsp;
                    My child's teacher is &nbsp;
                    <input type='text' id='txtChildsTeacher' name='txtChildsTeacher' className='add-only w-200 custom-add-only' />.
                </p>

                <p className='w-750'>
                    {`By granting consent, I am allowing the staff from Positive Direction Services to share information, including Psychiatric diagnosis, medications and the treatment plan with the appropriate school personnel (e.g., Principal, Social Worker, School Counselor, or Sp. Education Teacher) consistent with HIPAA requirements.`}
                </p>

                <p className='w-750'>
                    {`I am also giving permission for the above named school to share information with Positive Direction Support Services, including the child's progress both academically and behaviorally, along with any IEP, IAP or other pertinent information where applicable.`}
                </p>

                <p className='w-750'>
                    You may contact Positive Direction Support Services at 504-944-0453 with any questions.
                </p>

                <p className='w-750'>
                    Sincerely,
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent/Guardian Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center><h4>Healthy Living Questionnaire 2011</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Program:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtName_8' name='txtName_8' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtProgram' name='txtProgram' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Are you working on heath goals in any of the following areas?:</span> </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealth_4' name='cbMentalHealth_4' className='add-only' value='Mental Health' /> Mental Health </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCheckUps' name='cbCheckUps' className='add-only' value='Check-ups' /> Check-ups </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbExercise' name='cbExercise' className='add-only' value='Exercise' /> Exercise </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHealthyFoods' name='cbHealthyFoods' className='add-only' value='Healthy Foods' /> Healthy Foods </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSex' name='cbSex' className='add-only' value='Sex' /> Sex </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedications' name='cbMedications' className='add-only' value='Medications' /> Medications </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSmoking' name='cbSmoking' className='add-only' value='Smoking' /> Smoking </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEr' name='cbEr' className='add-only' value='ER' /> ER </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCopd' name='cbCopd' className='add-only' value='COPD' /> COPD </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTeeth' name='cbTeeth' className='add-only' value='Teeth' /> Teeth </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>I participate in the Healthy Living Program: (Check all that apply)</span>
                    <input type='checkbox' id='cbInGroups' name='cbInGroups' className='add-only' value='In groups' /> In groups &nbsp; &nbsp;
                    <input type='checkbox' id='cbDiscussions' name='cbDiscussions' className='add-only' value='Through discussions' /> Through discussions with my clinician
                </p>

                <p className='w-750'> <span className='eleHeader'><b>1.</b> Overall, how would you rate your health during the past 4 weeks?</span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbExcellent' name='cbExcellent' className='add-only' value='Excellent' /> Excellent </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbVeryGood' name='cbVeryGood' className='add-only' value='Very Good' /> Very Good </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbGood' name='cbGood' className='add-only' value='Good' /> Good </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFair' name='cbFair' className='add-only' value='Fair' /> Fair </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPoor' name='cbPoor' className='add-only' value='Poor' /> Poor </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbVeryPoor' name='cbVeryPoor' className='add-only' value='Very Poor' /> Very Poor </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'><b>2.</b> {`During the past 4 weeks, how much did physical health problems limit your usual physical activities (such as walking or climbing stairs)?`}</span>
                    <input type='checkbox' id='cbNotAtAll' name='cbNotAtAll' className='add-only' value='Not at all' /> Not at all <br />
                    <input type='checkbox' id='cbVeryLittle' name='cbVeryLittle' className='add-only' value='Very little' /> Very little <br />
                    <input type='checkbox' id='cbSomewhat' name='cbSomewhat' className='add-only' value='Somewhat' /> Somewhat <br />
                    <input type='checkbox' id='cbQuiteAlot' name='cbQuiteAlot' className='add-only' value='Quite a lot' /> Quite a lot <br />
                    <input type='checkbox' id='cbPhysicalActivities' name='cbPhysicalActivities' className='add-only' value='Could not do physical activities' /> Could not do physical activities
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>3.</b> {`During the past 4 weeks, how much difficulty did you have doing your daily work, both at home and away from home, because of your physical health?`}</span>
                    <input type='checkbox' id='cbNotAtAll_1' name='cbNotAtAll_1' className='add-only' value='Not at all' /> Not at all
                    <br />
                    <input type='checkbox' id='cbLittleBit' name='cbLittleBit' className='add-only' value='A little bit' /> A little bit
                    <br />
                    <input type='checkbox' id='cbSome' name='cbSome' className='add-only' value='Some' /> Some
                    <br />
                    <input type='checkbox' id='cbQuiteAlot_1' name='cbQuiteAlot_1' className='add-only' value='Quite a lot' /> Quite a lot <br />
                    <input type='checkbox' id='cbDailyWork' name='cbDailyWork' className='add-only' value='Could not do daily work' /> Could not do daily work
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>4.</b> {`How much bodily pain have you had during the past 4 weeks?`}</span>
                    <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='None' /> None
                    <br />
                    <input type='checkbox' id='cbVeryMild' name='cbVeryMild' className='add-only' value='Very mild' /> Very mild
                    <br />
                    <input type='checkbox' id='cbMild' name='cbMild' className='add-only' value='Mild' /> Mild
                    <br />
                    <input type='checkbox' id='cbModerate' name='cbModerate' className='add-only' value='Moderate' /> Moderate
                    <br />
                    <input type='checkbox' id='cbSevere' name='cbSevere' className='add-only' value='Severe' /> Severe
                    <br />
                    <input type='checkbox' id='cbVerySevere' name='cbVerySevere' className='add-only' value='Very Severe' /> Very Severe
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>5.</b> {`During the past 4 weeks, how much energy did you have?`}</span>
                    <input type='checkbox' id='cbVeryMuch' name='cbVeryMuch' className='add-only' value='Very much' /> Very much
                    <br />
                    <input type='checkbox' id='cbQuiteAlot_2' name='cbQuiteAlot_2' className='add-only' value='Quite a lot' /> Quite a lot
                    <br />
                    <input type='checkbox' id='cbSome_1' name='cbSome_1' className='add-only' value='Some' /> Some
                    <br />
                    <input type='checkbox' id='cbLittle' name='cbLittle' className='add-only' value='A little' /> A little
                    <br />
                    <input type='checkbox' id='cbNone_1' name='cbNone_1' className='add-only' value='None' /> None
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>6.</b> {`During the past 4 weeks, how much did your physical health or emotional problems limit your usual social activities with family or friends?`}</span>
                    <input type='checkbox' id='cbNotAtAll_2' name='cbNotAtAll_2' className='add-only' value='Not at all' /> Not at all
                    <br />
                    <input type='checkbox' id='cbVerylittle' name='cbVerylittle' className='add-only' value='Very little' /> Very little
                    <br />
                    <input type='checkbox' id='cbSomewhat_1' name='cbSomewhat_1' className='add-only' value='Somewhat' /> Somewhat
                    <br />
                    <input type='checkbox' id='cbQuiteAlot_3' name='cbQuiteAlot_3' className='add-only' value='Quite a lot' /> Quite a lot
                    <br />
                    <input type='checkbox' id='cbSocialActivities' name='cbSocialActivities' className='add-only' value='Could not do social activities' /> Could not do social activities
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>7.</b> {`During the past 4 weeks, how much have you been bothered by emotional problems (such as feeling anxious, depressed or irritable)?`}</span>
                    <input type='checkbox' id='cbNotAtAll_3' name='cbNotAtAll_3' className='add-only' value='Not at all' /> Not at all
                    <br />
                    <input type='checkbox' id='cbSlightly' name='cbSlightly' className='add-only' value='Slightly' /> Slightly
                    <br />
                    <input type='checkbox' id='cbModerate_1' name='cbModerate_1' className='add-only' value='Moderate' /> Moderate
                    <br />
                    <input type='checkbox' id='cbQuiteAlot_4' name='cbQuiteAlot_4' className='add-only' value='Quite a lot' /> Quite a lot
                    <br />
                    <input type='checkbox' id='cbExtremely' name='cbExtremely' className='add-only' value='Extremely' /> Extremely
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>8.</b> {`During the past 4 weeks, how much did personal or emotional problems keep you from doing your usual work, school or other daily activities?`}</span>
                    <input type='checkbox' id='cbNotAtAll_4' name='cbNotAtAll_4' className='add-only' value='Not at all' /> Not at all
                    <br />
                    <input type='checkbox' id='cbVerylittle_1' name='cbVerylittle_1' className='add-only' value='Very little' /> Very little
                    <br />
                    <input type='checkbox' id='cbSomewhat_2' name='cbSomewhat_2' className='add-only' value='Somewhat' /> Somewhat
                    <br />
                    <input type='checkbox' id='cbQuiteAlot_5' name='cbQuiteAlot_5' className='add-only' value='Quite a lot' /> Quite a lot
                    <br />
                    <input type='checkbox' id='cbDailyActivities' name='cbDailyActivities' className='add-only' value='Could not do daily activities' /> Could not do daily activities
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>9.</b> {`During the past 4 weeks, how often did your dinner include at least one vegetable per day?`}</span>
                    <input type='checkbox' id='cbNotAtAll_5' name='cbNotAtAll_5' className='add-only' value='Not at all' /> Not at all
                    <br />
                    <input type='checkbox' id='cbVerylittle_2' name='cbVerylittle_2' className='add-only' value='Very little' /> Very little
                    <br />
                    <input type='checkbox' id='cbSometimes' name='cbSometimes' className='add-only' value='Sometimes' /> Sometimes
                    <br />
                    <input type='checkbox' id='cbQuiteAlot_6' name='cbQuiteAlot_6' className='add-only' value='Quite a lot' /> Quite a lot
                    <br />
                    <input type='checkbox' id='cbAllTheTime' name='cbAllTheTime' className='add-only' value='All the time' /> All the time
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>10.</b> {`During the past 4 weeks, how often did you engage in some form of exercise?`}</span>
                    <input type='checkbox' id='cbNotAtAll_6' name='cbNotAtAll_6' className='add-only' value='Not at all' /> Not at all
                    <br />
                    <input type='checkbox' id='cbVerylittle_3' name='cbVerylittle_3' className='add-only' value='Very little' /> Very little
                    <br />
                    <input type='checkbox' id='cbSometimes_1' name='cbSometimes_1' className='add-only' value='Sometimes' /> Sometimes
                    <br />
                    <input type='checkbox' id='cbQuiteAlot_7' name='cbQuiteAlot_7' className='add-only' value='Quite a lot' /> Quite a lot
                    <br />
                    <input type='checkbox' id='cbVeryFrequently' name='cbVeryFrequently' className='add-only' value='Very frequently' /> Very frequently
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>11.</b> {`During the past 4 weeks, how often did you take all of your medications as prescribed?`}</span>
                    <input type='checkbox' id='cbNotAtAll_7' name='cbNotAtAll_7' className='add-only' value='Not at all' /> Not at all <br />
                    <input type='checkbox' id='cbVerylittle_4' name='cbVerylittle_4' className='add-only' value='Very little' /> Very little
                    <br />
                    <input type='checkbox' id='cbSometimes_2' name='cbSometimes_2' className='add-only' value='Sometimes' /> Sometimes
                    <br />
                    <input type='checkbox' id='cbQuiteAlot_8' name='cbQuiteAlot_8' className='add-only' value='Quite a lot' /> Quite a lot
                    <br />
                    <input type='checkbox' id='cbAllTheTime_1' name='cbAllTheTime_1' className='add-only' value='All the time' /> All the time
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>12.</b> {`During the past 4 weeks, how often did you brush your teeth twice a day?`}</span>
                    <input type='checkbox' id='cbNotAtAll_8' name='cbNotAtAll_8' className='add-only' value='Not at all' /> Not at all
                    <br />
                    <input type='checkbox' id='cbRarely' name='cbRarely' className='add-only' value='Rarely' /> Rarely
                    <br />
                    <input type='checkbox' id='cbUsually' name='cbUsually' className='add-only' value='Usually' /> Usually
                    <br />
                    <input type='checkbox' id='cbAllTheTime_2' name='cbAllTheTime_2' className='add-only' value='All the time' /> All the time
                    <br />
                    <input type='checkbox' id='cbNotApplicable' name='cbNotApplicable' className='add-only' value='Not applicable' /> Not applicable
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>13.</b> {`During the past 4 weeks, when having sex, how often did you use a condom?`}</span>
                    <input type='checkbox' id='cbNotAtAll_9' name='cbNotAtAll_9' className='add-only' value='Not at all' /> Not at all
                    <br />
                    <input type='checkbox' id='cbRarely_1' name='cbRarely_1' className='add-only' value='Rarely' /> Rarely
                    <br />
                    <input type='checkbox' id='cbUsually_1' name='cbUsually_1' className='add-only' value='Usually' /> Usually
                    <br />
                    <input type='checkbox' id='cbAllTheTime_3' name='cbAllTheTime_3' className='add-only' value='All the time' /> All the time
                    <br />
                    <input type='checkbox' id='cbNotApplicable_1' name='cbNotApplicable_1' className='add-only' value='Not applicable' /> Not applicable
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>14.</b> {`14. During the past 4 weeks, how often did you smoke?`}</span>
                    <input type='checkbox' id='cbNotAtAll_10' name='cbNotAtAll_10' className='add-only' value='Not at all' /> Not at all
                    <br />
                    <input type='checkbox' id='cbVerylittle_5' name='cbVerylittle_5' className='add-only' value='Very little' /> Very little
                    <br />
                    <input type='checkbox' id='cbSometimes_3' name='cbSometimes_3' className='add-only' value='Sometimes' /> Sometimes
                    <br />
                    <input type='checkbox' id='cbQuiteAlot_9' name='cbQuiteAlot_9' className='add-only' value='Quite a lot' /> Quite a lot
                    <br />
                    <input type='checkbox' id='cbVeryFrequently_1' name='cbVeryFrequently_1' className='add-only' value='Very frequently' /> Very frequently
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>15.</b> I believe that I can make changes that will improve my physical health.</span>
                    <input type='checkbox' id='cbTotallyAgree' name='cbTotallyAgree' className='add-only' value='Totally agree' /> Totally agree
                    <br />
                    <input type='checkbox' id='cbAgreeLittle' name='cbAgreeLittle' className='add-only' value='Agree a little' /> Agree a little
                    <br />
                    <input type='checkbox' id='cbDisagree' name='cbDisagree' className='add-only' value='Disagree' /> Disagree
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>16.</b> I believe that I can make changes that will improve my mental health </span>
                    <input type='checkbox' id='cbTotallyAgree_1' name='cbTotallyAgree_1' className='add-only' value='Totally agree' /> Totally agree
                    <br />
                    <input type='checkbox' id='cbAgreeLittle_1' name='cbAgreeLittle_1' className='add-only' value='Agree a little' /> Agree a little
                    <br />
                    <input type='checkbox' id='cbDisagree_1' name='cbDisagree_1' className='add-only' value='Disagree' /> Disagree
                </p>

                <p className='w-750'>
                    <b>Please note that the following questions refer to different time frames than the previous questions.</b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>17.</b> During the past year, how often did you visit your primary care provider? </span>
                    <input type='checkbox' id='cbZeroTimes' name='cbZeroTimes' className='add-only' value='0 times' /> 0 times
                    &nbsp;
                    <input type='checkbox' id='cbOneTime' name='cbOneTime' className='add-only' value='1 time' /> 1 time
                    &nbsp;
                    <input type='checkbox' id='cbTwoTimes' name='cbTwoTimes' className='add-only' value='2 times' /> 2 times
                    &nbsp;
                    <input type='checkbox' id='cbThreeTimes' name='cbThreeTimes' className='add-only' value='3 times' /> 3 times
                    &nbsp;
                    <input type='checkbox' id='cbFourTimes' name='cbFourTimes' className='add-only' value='4 or more times' /> 4 or more times
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>18.</b> During the past 3 months, how many times did you visit the Emergency Room? </span>
                    <input type='checkbox' id='cbZeroTimes_1' name='cbZeroTimes_1' className='add-only' value='0 times' /> 0 times
                    &nbsp;
                    <input type='checkbox' id='cbOneTime_1' name='cbOneTime_1' className='add-only' value='1 time' /> 1 time
                    &nbsp;
                    <input type='checkbox' id='cbTwoTimes_1' name='cbTwoTimes_1' className='add-only' value='2 times' /> 2 times
                    &nbsp;
                    <input type='checkbox' id='cbThreeTimes_1' name='cbThreeTimes_1' className='add-only' value='3 times' /> 3 times
                    &nbsp;
                    <input type='checkbox' id='cbFourTimes_1' name='cbFourTimes_1' className='add-only' value='4 or more times' /> 4 or more times
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>The reason was (check all that apply): </span>
                    <input type='checkbox' id='cbMyMentalHealth' name='cbMyMentalHealth' className='add-only' value='My mental health' /> My mental health
                    &nbsp;
                    <input type='checkbox' id='cbPhysicalHealth' name='cbPhysicalHealth' className='add-only' value='My physical Health' /> My physical Health
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><b>19.</b> During the past 3 months, how many times were you admitted to a hospital? </span>
                    <input type='checkbox' id='cbZeroTimes_2' name='cbZeroTimes_2' className='add-only' value='0 times' /> 0 times
                    &nbsp;
                    <input type='checkbox' id='cbOneTime_2' name='cbOneTime_2' className='add-only' value='1 time' /> 1 time
                    &nbsp;
                    <input type='checkbox' id='cbTwoTimes_2' name='cbTwoTimes_2' className='add-only' value='2 times' /> 2 times
                    &nbsp;
                    <input type='checkbox' id='cbThreeTimes_2' name='cbThreeTimes_2' className='add-only' value='3 times' /> 3 times
                    &nbsp;
                    <input type='checkbox' id='cbFourTimes_2' name='cbFourTimes_2' className='add-only' value='4 or more times' /> 4 or more times
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>The reason was (check all that apply): </span>
                    <input type='checkbox' id='cbMyMentalHealth_1' name='cbMyMentalHealth_1' className='add-only' value='My mental health' /> My mental health
                    &nbsp;
                    <input type='checkbox' id='cbPhysicalHealth_1' name='cbPhysicalHealth_1' className='add-only' value='My physical Health' /> My physical Health
                </p>

                <p className='w-750'>
                    <center><b>Thank you for completing these questions!</b></center>
                </p>

                <p className='w-750'>
                    Positive Direction Support Services, LLC <br />
                    1995 Gentilly Blvd. Suite C-400 <br />
                    New Orleans, LA 70119 <br />
                    Phone: (504) 944-0453 Fax: (504) 944-0095
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Client:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Parent/Guardian:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClient' name='txtClient' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtParent' name='txtParent' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    In the event of a crisis, the first responder is your CSW (Community Support Worker):
                </p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Telephone Number (Cell):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtName_9' name='txtName_9' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtCell' name='txtCell' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>If your CSW (Community Support Worker) cannot be reached, call:</b> PDSS 24/7 Crisis Line... <br />
                    <b>Telephone Number: (504) 421-2107 Donnyette J. Love, LCSW</b>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    If you have any questions, please call the office. Thank you.
                </p>

                <p className='w-750'>
                    <center><h4>ISRP Signature Sheet</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'> Print Client's Name </td>
                        <td className='small w-300'> ISRP </td>
                        <td className='small w-150'> Client's DOB </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent's/Guardian's Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> CSW's/LMHP's Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>~ This form is to verify that you the parent/guardian have received a copy of the ISRP for the client listed above. ~</b>
                </p>

                <p className='w-750'>
                    <b>Section Eight: Signatures</b>
                </p>

                <p className='w-750'>
                    <b>MHR Agency Staff</b> <span className='small'>Check all the applies</span>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbLegalGuardian' name='cbLegalGuardian' className='add-only' value='Legal Guardian' /> <b>1.</b>{`The treatment team certifies that it met face-to-face with the recipient and/or caregiver or legal guardian to collaboratively identify services.`}
                    <br />
                    <input type='checkbox' id='cbOngoingAssessment' name='cbOngoingAssessment' className='add-only' value='Ongoing Assessment' /> <b>2.</b>The treatment team certifies that the services requested in this ISRP are based on an initial and ongoing assessment.
                    <br />
                    <input type='checkbox' id='cbMedicallyNecessary' name='cbMedicallyNecessary' className='add-only' value='Medically Necessary' /> <b>3.</b>{`The treatment team certifies that the services requested in this ISRP are medically necessary, appropriate, and comprehensive in approach.`}
                    <br />
                    <input type='checkbox' id='cbFinsPlan' name='cbFinsPlan' className='add-only' value='FINS Plan' /> <b>4.</b>{`The treatment team certifies that the ISRP is consistent with the recipient's ISC Plan, FINS Plan, and/or other interagency plan if any such plan(s) exist.`}
                    <br />
                    <input type='checkbox' id='cbRehabilitativeOutcome' name='cbRehabilitativeOutcome' className='add-only' value='Rehabilitative Outcome' /> <b>5.</b>The treatment team's professional opinion is that the recipient is ready to engage in the Mental Health Rehabilitation services requested in this ISRP and it is reasonable to expect a rehabilitative outcome.
                </p>

                <p className='w-750'>
                    <center><h4>Recipient/Natural Support</h4></center>
                </p>

                <p className='w-750'>
                    <b>Check all that applies. The parent/guardian and recipients over the age of 6 must sign the ISRP.</b>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbPsychiatrist' name='cbPsychiatrist' className='add-only' value='Psychiatrist' /> <b>1.</b>{`I participated face-to-face with the psychiatrist and/or licensed mental health professional whose signature is below in identifying my needs and in developing this Mental Health Rehabilitation Service Plan which reflects my goals and objectives.`}
                    <br />
                    <input type='checkbox' id='cbMentalHealth_5' name='cbMentalHealth_5' className='add-only' value='Mental Health' /> <b>2.</b>I freely choose to receive and participate in the Mental Health Rehabilitation services requested in the ISRP.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Recipient </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent/Guardian </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Primary LMHP </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Com.Support Worker </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Psychiatrist </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Other </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>Section Eight: Signatures</b>
                </p>

                <p className='w-750'>
                    <b>MHR Agency Staff</b> <span className='small'>Check all the applies</span>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbLegalGuardian_1' name='cbLegalGuardian_1' className='add-only' value='Legal Guardian' /> <b>1.</b>{`The treatment team certifies that it met face-to-face with the recipient and/or caregiver or legal guardian to collaboratively identify services.`}
                    <br />
                    <input type='checkbox' id='cbOngoingAssessment_1' name='cbOngoingAssessment_1' className='add-only' value='Ongoing Assessment' /> <b>2.</b>The treatment team certifies that the services requested in this ISRP are based on an initial and ongoing assessment.
                    <br />
                    <input type='checkbox' id='cbMedicallyNecessary_1' name='cbMedicallyNecessary_1' className='add-only' value='Medically Necessary' /> <b>3.</b>{`The treatment team certifies that the services requested in this ISRP are medically necessary, appropriate, and comprehensive in approach.`}
                    <br />
                    <input type='checkbox' id='cbFinsPlan_1' name='cbFinsPlan_1' className='add-only' value='FINS Plan' /> <b>4.</b>{`The treatment team certifies that the ISRP is consistent with the recipient's ISC Plan, FINS Plan, and/or other interagency plan if any such plan(s) exist.`}
                    <br />
                    <input type='checkbox' id='cbRehabilitativeOutcome_1' name='cbRehabilitativeOutcome_1' className='add-only' value='Rehabilitative Outcome' /> <b>5.</b>The treatment team's professional opinion is that the recipient is ready to engage in the Mental Health Rehabilitation services requested in this ISRP and it is reasonable to expect a rehabilitative outcome.
                </p>

                <p className='w-750'>
                    <center><h4>Recipient/Natural Support</h4></center>
                </p>

                <p className='w-750'>
                    <b>Check all that applies. The parent/guardian and recipients over the age of 6 must sign the ISRP.</b>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbPsychiatrist_1' name='cbPsychiatrist_1' className='add-only' value='Psychiatrist' /> <b>1.</b>{`I participated face-to-face with the psychiatrist and/or licensed mental health professional whose signature is below in identifying my needs and in developing this Mental Health Rehabilitation Service Plan which reflects my goals and objectives.`}
                    <br />
                    <input type='checkbox' id='cbMentalHealth_6' name='cbMentalHealth_6' className='add-only' value='Mental Health' /> <b>2.</b>I freely choose to receive and participate in the Mental Health Rehabilitation services requested in the ISRP.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Recipient </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent/Guardian </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Primary LMHP </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Com.Support Worker </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Psychiatrist </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Other </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>Section Eight: Signatures</b>
                </p>

                <p className='w-750'>
                    <b>MHR Agency Staff</b> <span className='small'>Check all the applies</span>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbLegalGuardian_2' name='cbLegalGuardian_2' className='add-only' value='Legal Guardian' /> <b>1.</b>{`The treatment team certifies that it met face-to-face with the recipient and/or caregiver or legal guardian to collaboratively identify services.`}
                    <br />
                    <input type='checkbox' id='cbOngoingAssessment_2' name='cbOngoingAssessment_2' className='add-only' value='Ongoing Assessment' /> <b>2.</b>The treatment team certifies that the services requested in this ISRP are based on an initial and ongoing assessment.
                    <br />
                    <input type='checkbox' id='cbMedicallyNecessary_2' name='cbMedicallyNecessary_2' className='add-only' value='Medically Necessary' /> <b>3.</b>{`The treatment team certifies that the services requested in this ISRP are medically necessary, appropriate, and comprehensive in approach.`}
                    <br />
                    <input type='checkbox' id='cbFinsPlan_2' name='cbFinsPlan_2' className='add-only' value='FINS Plan' /> <b>4.</b>{`The treatment team certifies that the ISRP is consistent with the recipient's ISC Plan, FINS Plan, and/or other interagency plan if any such plan(s) exist.`}
                    <br />
                    <input type='checkbox' id='cbRehabilitativeOutcome_2' name='cbRehabilitativeOutcome_2' className='add-only' value='Rehabilitative Outcome' /> <b>5.</b>The treatment team's professional opinion is that the recipient is ready to engage in the Mental Health Rehabilitation services requested in this ISRP and it is reasonable to expect a rehabilitative outcome.
                </p>

                <p className='w-750'>
                    <center><h4>Recipient/Natural Support</h4></center>
                </p>

                <p className='w-750'>
                    <b>Check all that applies. The parent/guardian and recipients over the age of 6 must sign the ISRP.</b>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbPsychiatrist_2' name='cbPsychiatrist_2' className='add-only' value='Psychiatrist' /> <b>1.</b>{`I participated face-to-face with the psychiatrist and/or licensed mental health professional whose signature is below in identifying my needs and in developing this Mental Health Rehabilitation Service Plan which reflects my goals and objectives.`}
                    <br />
                    <input type='checkbox' id='cbMentalHealth_7' name='cbMentalHealth_7' className='add-only' value='Mental Health' /> <b>2.</b>I freely choose to receive and participate in the Mental Health Rehabilitation services requested in the ISRP.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Recipient </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent/Guardian </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Primary LMHP </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Com.Support Worker </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Psychiatrist </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Other </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>Section Eight: Signatures</b>
                </p>

                <p className='w-750'>
                    <b>MHR Agency Staff</b> <span className='small'>Check all the applies</span>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbLegalGuardian_3' name='cbLegalGuardian_3' className='add-only' value='Legal Guardian' /> <b>1.</b>{`The treatment team certifies that it met face-to-face with the recipient and/or caregiver or legal guardian to collaboratively identify services.`}
                    <br />
                    <input type='checkbox' id='cbOngoingAssessment_3' name='cbOngoingAssessment_3' className='add-only' value='Ongoing Assessment' /> <b>2.</b>The treatment team certifies that the services requested in this ISRP are based on an initial and ongoing assessment.
                    <br />
                    <input type='checkbox' id='cbMedicallyNecessary_3' name='cbMedicallyNecessary_3' className='add-only' value='Medically Necessary' /> <b>3.</b>{`The treatment team certifies that the services requested in this ISRP are medically necessary, appropriate, and comprehensive in approach.`}
                    <br />
                    <input type='checkbox' id='cbFinsPlan_3' name='cbFinsPlan_3' className='add-only' value='FINS Plan' /> <b>4.</b>{`The treatment team certifies that the ISRP is consistent with the recipient's ISC Plan, FINS Plan, and/or other interagency plan if any such plan(s) exist.`}
                    <br />
                    <input type='checkbox' id='cbRehabilitativeOutcome_3' name='cbRehabilitativeOutcome_3' className='add-only' value='Rehabilitative Outcome' /> <b>5.</b>The treatment team's professional opinion is that the recipient is ready to engage in the Mental Health Rehabilitation services requested in this ISRP and it is reasonable to expect a rehabilitative outcome.
                </p>

                <p className='w-750'>
                    <center><h4>Recipient/Natural Support</h4></center>
                </p>

                <p className='w-750'>
                    <b>Check all that applies. The parent/guardian and recipients over the age of 6 must sign the ISRP.</b>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbPsychiatrist_3' name='cbPsychiatrist_3' className='add-only' value='Psychiatrist' /> <b>1.</b>{`I participated face-to-face with the psychiatrist and/or licensed mental health professional whose signature is below in identifying my needs and in developing this Mental Health Rehabilitation Service Plan which reflects my goals and objectives.`}
                    <br />
                    <input type='checkbox' id='cbMentalHealth_8' name='cbMentalHealth_8' className='add-only' value='Mental Health' /> <b>2.</b>I freely choose to receive and participate in the Mental Health Rehabilitation services requested in the ISRP.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Recipient </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent/Guardian </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Primary LMHP </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Com.Support Worker </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Psychiatrist </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Other </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>



            </div>
        </form>
    )
}
